export default "__VITE_ASSET__C3mW_X2i__"